import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { Link } from 'react-router-dom';
import logo from '../logo.png';
import { APP_STORE_URL } from '../constants';

const Footer = () => {
    const { getFullTranslation, language, setLanguage, languageNames, availableLanguages } = useLanguage();
    const footer = getFullTranslation('footer');
    const [isLangOpen, setIsLangOpen] = useState(false);
    const xiaohongshuUrl = 'https://xhslink.com/m/9qO0DwhnJwR';
    const icpRecordUrl = 'https://beian.miit.gov.cn/';
    const icpRecordNumber = '粤ICP备2026058247号-1';

    const toggleLangMenu = () => {
        setIsLangOpen(!isLangOpen);
    };

    const selectLanguage = (lang) => {
        setLanguage(lang);
        setIsLangOpen(false);
    };

    return (
        <footer className="bg-[#163020] text-white pt-16">
            {/* Action Buttons Top */}
            <div className="flex flex-wrap justify-center gap-4 mb-20 px-4">
                <Link to="/help" className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3 rounded-lg font-medium transition text-center">
                    {footer.helpCenter}
                </Link>
                <a href="mailto:andy.caoyueyang@gmail.com" className="bg-white text-gray-800 hover:bg-gray-100 px-8 py-3 rounded-lg font-medium transition shadow-sm text-center">
                    {footer.sendFeedback}
                </a>
                <a href="mailto:andy.caoyueyang@gmail.com" className="bg-white text-gray-800 hover:bg-gray-100 px-8 py-3 rounded-lg font-medium transition shadow-sm text-center">
                    {footer.contactEmail}
                </a>
            </div>

            <div className="max-w-7xl mx-auto px-6 pb-12 border-b border-orange-900/50">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
                    {/* Logo & Info */}
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex items-center space-x-3 mb-6">
                            <img src={logo} alt="食光机" className="w-10 h-10 rounded-xl" />
                            <span className="text-2xl font-bold">食光机</span>
                        </div>

                        <div className="relative">
                            <button
                                onClick={toggleLangMenu}
                                className="flex items-center px-4 py-2 bg-white/10 text-gray-300 font-medium rounded-lg hover:bg-white/20 mt-16 mt-auto transition"
                            >
                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"></path></svg>
                                {languageNames[language]}
                                <svg className={`w-4 h-4 ml-1 transition-transform ${isLangOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </button>

                            {isLangOpen && (
                                <div className="absolute left-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
                                    {availableLanguages.map((lang) => (
                                        <button
                                            key={lang}
                                            onClick={() => selectLanguage(lang)}
                                            className={`w-full text-left px-4 py-2 hover:bg-orange-50 transition-colors ${language === lang ? 'text-orange-600 font-medium' : 'text-gray-700'
                                                }`}
                                        >
                                            {languageNames[lang]}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Links Columns */}
                    <div>
                        <h4 className="font-semibold text-orange-300 mb-6 text-lg">{footer.product}</h4>
                        <ul className="space-y-4 text-orange-100/70">
                            <li><a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">{footer.iosDownload}</a></li>
                            <li><Link to="/features" className="hover:text-white transition">{footer.coreFeatures}</Link></li>
                            <li><Link to="/subscription" className="hover:text-white transition">{footer.subscription}</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold text-orange-300 mb-6 text-lg">{footer.support}</h4>
                        <ul className="space-y-4 text-orange-100/70">
                            <li><a href="/#faq" className="hover:text-white transition">{footer.faq}</a></li>
                            <li><Link to="/changelog" className="hover:text-white transition">{footer.changelog}</Link></li>
                            <li><a href={xiaohongshuUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">{footer.contact}</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold text-orange-300 mb-6 text-lg">{footer.about}</h4>
                        <ul className="space-y-4 text-orange-100/70">
                            <li><Link to="/privacy" className="hover:text-white transition">{footer.privacy}</Link></li>
                            <li><Link to="/terms" className="hover:text-white transition">{footer.terms}</Link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row justify-between items-center gap-4 text-orange-100/50 text-sm">
                <div className="flex flex-col items-center md:items-start gap-2">
                    <p>{footer.copyright}</p>
                    <a href={icpRecordUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">
                        {icpRecordNumber}
                    </a>
                </div>
                <div className="flex mt-0 md:mt-0">
                    <a href={xiaohongshuUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">{footer.xiaohongshu}</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
